import { render, staticRenderFns } from "./SetAskPriceModal.vue?vue&type=template&id=10dd305e&"
import script from "./SetAskPriceModal.vue?vue&type=script&lang=js&"
export * from "./SetAskPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports